import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Close from '../Icons/Close';

const PopUpImg = ({ isPopUpImg, close, url }) => {
  return (
    <Fragment>
      {isPopUpImg ? (
        <Fragment>
          <div className="fullscreen">
            <img
              src={url}
              alt="imagePreview"
              className="img-fluid img-thumbnail"
            />
            <span onClick={close} className="close">
              <Close size="md" />
            </span>
          </div>
        </Fragment>
      ) : null}
    </Fragment>
  );
};

PopUpImg.propTypes = {
  isFullScreen: PropTypes.bool,
  close: PropTypes.func,
  url: PropTypes.string,
};

export default PopUpImg;